// extracted by mini-css-extract-plugin
export default {"root":"SectionJobTypes_root__j4+uU","typesOfJob":"SectionJobTypes_typesOfJob__exTav","item":"SectionJobTypes_item__SFwFH","itemTitle":"SectionJobTypes_itemTitle__36CB1"};